import React from 'react';

/* packages */
import { ModuleTitle } from '../../util-atomic-design';
/* packages */

const Index = props => {
  return <ModuleTitle>
    Summary
  </ModuleTitle>
}

export default Index;
